export default {
  inject: ['load'],
  data() {
    return {
      allSkinTemperaturesForOther: [],
      skinTemperature: null,
    };
  },
  methods: {
    getListOfSkinTemperaturesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllSkinTemperatures').then(() => {
        if (this.$store.state.skinTemperatureModule.successFlag) {
          this.allSkinTemperaturesForOther =
            this.$store.state.skinTemperatureModule.allSkinTemperatures;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.skinTemperatureModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfSkinTemperaturesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getSkinTemperatureFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getSkinTemperature', id).then(() => {
        if (this.$store.state.skinTemperatureModule.successFlag) {
          this.skinTemperature = this.$store.state.skinTemperatureModule.skinTemperature;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.skinTemperatureModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getSkinTemperatureFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.skinTemperatureModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
